import { createAuthClient } from "better-auth/react";
import {
  organizationClient,
  twoFactorClient,
  adminClient,
  magicLinkClient,
  emailOTPClient,
} from "better-auth/client/plugins";
import { passkeyClient } from "@better-auth/passkey/client";
import config from "../config";

export const authClient = createAuthClient({
  baseURL: config.api.API_URL,
  plugins: [
    organizationClient(),
    twoFactorClient(),
    passkeyClient(),
    adminClient(),
    magicLinkClient(),
    emailOTPClient(),
  ],
});

export const { useSession, signIn, signUp, signOut } = authClient;
